import {FaArrowLeft} from "react-icons/fa";
import {useLang} from "../context/LanguageContext";
import {useNavigate} from "react-router-dom";


export default function BackGreenButton(){
    const { t } = useLang();
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate('/')}
            className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
        >
            <FaArrowLeft/>
            <span className="text-white">{t('btn.back')}</span>
        </button>
    )
}